import ServerValidator from '@/server-validator'

/**
 * Plugin to enable validation using refs or name tags with a specified suffix to Vue.$validate
 * This binds server side validation results
 *
 * @export Function The plugin.
 * @returns The plugin.
 */
export default function plugin() {

    return function install(Vue) {

        Object.defineProperty(Vue.prototype, '$serverValidator', {
            get() {
                return ServerValidator
            },
        })
    }
}
